import script from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"

import "./MenuCategory.vue?vue&type=style&index=0&id=7909286e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7909286e"]])

export default __exports__